import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  GET_DETAIL_STOCKS,
  SELECT_STOCK_ITEM,
  SELECT_TIME_SELECTION,
  GET_STOCK_INFO,
  TOGGLE_SEVERITY,
  GET_DASHBOARD_USERS,
  RESET_VIEWSUMMARY_PAGE_MYDATA,
} from "../actions/constant";
import _ from "lodash";
import moment from "moment";
import { checkMarker } from "../lib/helper";

const chartLablesMaker = (period) => {
  switch (period) {
    case "1M":
      let result = [
        moment().add(-4, "weeks"),
        moment().add(-3, "weeks"),
        moment().add(-2, "weeks"),
        moment().add(-1, "weeks"),
        moment().endOf("day"),
      ];
      return result;
    case "3M":
      result = [
        moment().add(-91, "days"),
        moment().add(-75, "days"),
        moment().add(-60, "days"),
        moment().add(-45, "days"),
        moment().add(-30, "days"),
        moment().add(-16, "days"),
        moment().endOf("day"),
      ];
      return result;
    case "6M":
      result = [
        moment().add(-6, "months"),
        moment().add(-5, "months"),
        moment().add(-4, "months"),
        moment().add(-3, "months"),
        moment().add(-2, "months"),
        moment().add(-1, "months"),
        moment().endOf("day"),
      ];
      return result;
    case "1Y":
      result = [];
      for (let i = 0; i < 13; i = i + 3) {
        var newDate = moment().endOf("day").add(-i, "months");
        result.unshift(newDate);
      }
      return result;
    case "2Y":
      result = [];
      for (let i = 0; i < 25; i = i + 6) {
        var newDate = moment().endOf("day").add(-i, "months");
        result.unshift(newDate);
      }
      return result;
    default:
      break;
  }
};

const initialState = {
  allUser: [],
  isLoading: false,
  stocks: [],
  selected: { graph: [], news: [], forum: [] },
  selectedUser: {},
  timeSelection: "1M",
  chartPeriod: chartLablesMaker("1M"),
  DateMode: false,
  selectedSymptom: "",
  customSymptom: false,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_DASHBOARD_USERS:
      let data = [action.data];
      localStorage.setItem("user", JSON.stringify(data[0]));
      if (action.data.sub_users) data = [...data, ...action.data.sub_users];
      data = _.orderBy(
        data,
        [(user) => (user.first_name + " " + user.last_name).toLowerCase()],
        ["asc"]
      );
      return {
        ...state,
        allUser: data,
        isLoading: false,
      };
    case getStarted(GET_DETAIL_STOCKS):
      return { ...state, isLoading: true };
    case GET_DETAIL_STOCKS:
      data = action.data.Data;
      var selectedUser = action.selectedUser;
      if (!data) data = [];
      data = _.filter(data, function (item) {
        return item.participant == selectedUser._id.toString();
      });
      if (data.length <= 0) {
        data = { Symptoms: [] };
      } else {
        data = data[0];
      }
      data = _.filter(data.Symptoms, function (item) {
        return item.visibility;
      });
      data = data.map((item) => {
        item.order = parseInt(item.order);
        return item;
      });
      data = _.orderBy(data, ["order"]);

      return {
        ...state,
        isLoading: false,
        stocks: data,
        selectedUser: selectedUser,
        selected: { graph: [], news: [], forum: [] },
      };
    case SELECT_STOCK_ITEM:
      var st = state.stocks;
      if (st) {
        st.forEach((item) => {
          if (item._id == action.id) item.isSelected = 1;
          else item.isSelected = 0;
        });
      } else {
        action.item = [];
        action.id = "";
      }
      let symptomName = action.symptom;
      // let hasC = symptomName.toLowerCase().slice(-3) === "(c)" ? true : false;
      let hasC = checkMarker(symptomName, "C") ? true : false;
      return {
        ...state,
        isLoading: false,
        selected: action.item,
        selectedSymptom: action.id,
        stocks: st,
        customSymptom: hasC,
      };

    case getStarted(SELECT_STOCK_ITEM):
      return { ...state, isLoading: true };

    case SELECT_TIME_SELECTION:
      let selected = state.selected;
      if (action.item.graph) selected.graph = action.item.graph;
      else selected.graph = [];
      var period = action.item.time;
      return {
        ...state,
        chartPeriod: chartLablesMaker(period),
        timeSelection: period,
        selected: selected,
      };

    case getStarted(GET_STOCK_INFO):
      return { ...state, isLoading: false };

    case getSucceeded(GET_STOCK_INFO):
      let item = action.payload;
      let stocks = state.stocks.map((e) => {
        if (e._id === item.symptom) {
          e.state = item.state;
          e.severity = item.severity;
          e.type = item.unitid;
          e.created = item.date;
        }
        return e;
      });
      return { ...state, stocks: stocks, isLoading: false };

    case TOGGLE_SEVERITY:
      return { ...state, DateMode: !state.DateMode };
    case RESET_VIEWSUMMARY_PAGE_MYDATA:
      return initialState;

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/mainViewReducer.js